module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/92ce550a8e78c714b655580a03f37ddd.png";